/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Error_DescriptionInputs */

const en_app_error_description = /** @type {(inputs: App_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred. Try reloading the page or come back later.`)
};

const pt_br2_app_error_description = /** @type {(inputs: App_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro inesperado. Tente recarregar a página ou volte mais tarde.`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred. Try reloading the page or come back later." |
*
* @param {App_Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const app_error_description = /** @type {((inputs?: App_Error_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Error_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_error_description(inputs)
	return pt_br2_app_error_description(inputs)
});